/* eslint-disable react/prop-types */
import React from "react";

import { RotatingLines } from "react-loader-spinner";
import { Box, Typography } from "@mui/material";
import { DefaultLayoutZIndex } from "./../../_utils/constraints";

function LoadingBox({ isLoading, text,isFullScreen=true, styleLoadingBox = {} }) {
  if (!text || !isLoading) {
    return null; // Return early if there's no text
  }

  const loadingText =
    typeof text === "string" && text.trim() !== ""
      ? text
      : `Error in type of text: ${typeof text}`;
  return (
    <Box
      style={{
       ...isFullScreen&&{position: "fixed",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: DefaultLayoutZIndex + 5,
        padding: "0px 1rem",
        margin: "0px",
        width: "100%",
        minHeight: "100vh",
        opacity: 0.8,
        backgroundColor: "white",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,},
        ...styleLoadingBox,
      }}
    >
      <Box display="flex" justifyContent="center">
        <RotatingLines
          strokeColor="black"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </Box>
      <Box py={3} textAlign="center">
        <Typography variant="inherit" fontWeight="medium">
          {loadingText}
        </Typography>
      </Box>
    </Box>
  );
}

export default LoadingBox;
